import Icon from '@tribus/icon';

/**
  * @summary Cross icon component
  * @desc Element for declaring a circle icon
  * @author Wade Penistone <wade@tribusdigital.com>
  * @namespace CrossIcon
  * @constructor
  */
export default {
  name: 'cross-icon',
  extends: Icon,
  props: {
    base: {default: 'cross'},
    fillColor: {type: String, default: null}
  },
  mounted: function() {
    let shape = this.$el.querySelector('svg path');
    if (shape && this.fillColor) {
      shape.setAttribute('fill', this.fillColor);
    }
  }
};
